<template>
    <div class="login">
        <div class="left">
        </div>
        <div class="login-wrapper">
            <div class="turn">
                <span :class="login ? 'selected' : ''" @click="loginHandle">登录</span>
                <span :class="login ? '' : 'selected'" @click="regHandle">注册</span>
            </div>
            <!-- 登录 -->
            <div class="login-content" v-show="login">
                <el-form v-show="!phoneLogin" :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                    <el-form-item prop="account">
                        <el-input @keyup.enter.native="submitForm('ruleForm')" placeholder="请输入手机号/账号" v-model="ruleForm.account" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item prop="pass">
                        <el-input @keyup.enter.native="submitForm('ruleForm')" placeholder="请输入密码" show-password type="password" v-model="ruleForm.pass"></el-input>
                    </el-form-item>
                    <el-form-item prop="code" class="code-item">
                        <el-input @keyup.enter.native="submitForm('ruleForm')" placeholder="请输入验证码" v-model="ruleForm.code"></el-input>
                        <img class="code-img" :src="saveImg" alt="" @click="requsetValidateImg">
                    </el-form-item>
                    <el-form-item>
                        <el-button type="warning" @click="submitForm('ruleForm')">登录</el-button>
                    </el-form-item>
                </el-form>
                <!-- 短信登录布局 -->
                <el-form class="phone-form" v-show="phoneLogin" :model="phoneForm" status-icon :rules="phoneRules" ref="phoneForm" label-width="100px">
                    <el-form-item prop="phone">
                        <el-input @keyup.enter.native="submitForm('phoneForm')" placeholder="请输入手机号" v-model="phoneForm.phone" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item prop="imgCode" class="code-item">
                        <el-input @keyup.enter.native="submitForm('phoneForm')" placeholder="请输入验证码" v-model="phoneForm.imgCode"></el-input>
                        <img class="code-img" :src="saveImg" alt="" @click="requsetValidateImg">
                    </el-form-item>
                    <el-form-item prop="code" class="code-item">
                        <el-input @keyup.enter.native="submitForm('phoneForm')" placeholder="请输入短信验证码" v-model="phoneForm.code"></el-input>
                        <el-button :class="disabled ? 'disabled' : ''" type="warning" :disabled="disabled" @click="getPhoneCode('phoneForm')">{{disabled ? timeText : '获取验证码'}}</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="warning" @click="submitForm('phoneForm')">登录</el-button>
                    </el-form-item>
                </el-form>
                <div class="node" v-if="!phoneLogin" @click="nodeLogin">短信登录</div>
                <div class="node" v-else @click="passLogin">密码登录</div>
                <!-- <div class="login-bottom">
                    <el-divider>其他登录方式</el-divider>
                    <div class="fast-login">
                        <img :src="weixin" alt="">
                    </div>
                </div> -->
            </div>
            <!-- 注册 -->
            <div class="reg-main" v-show="!login">
                <el-form class="phone-form" :model="phoneReg" status-icon :rules="phoneRegRules" ref="phoneReg" label-width="100px">
                    <el-form-item prop="phone">
                        <el-input @keyup.enter.native="submitForm('phoneReg')" placeholder="请输入手机号" v-model="phoneReg.phone" autocomplete="off"></el-input>
                    </el-form-item>
                     <el-form-item prop="imgCode" class="code-item">
                        <el-input @keyup.enter.native="submitForm('phoneReg')" placeholder="请输入验证码" v-model="phoneReg.imgCode"></el-input>
                        <img class="code-img" :src="saveImg" alt="" @click="requsetValidateImg">
                    </el-form-item>
                    <el-form-item prop="code" class="code-item">
                        <el-input @keyup.enter.native="submitForm('phoneReg')" placeholder="请输入短信验证码" v-model="phoneReg.code"></el-input>
                        <el-button :class="disabled ? 'disabled' : ''" type="warning" :disabled="disabled" @click="getPhoneCode('phoneReg')">{{disabled ? timeText : '获取验证码'}}</el-button>
                    </el-form-item>
                    <el-form-item prop="pass">
                        <el-input @keyup.enter.native="submitForm('phoneReg')" placeholder="设置密码" show-password type="password" v-model="phoneReg.pass"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button :disabled="!checked" type="warning" @click="submitForm('phoneReg')">注册</el-button>
                    </el-form-item>
                </el-form>
                <div class="word">
                    <el-checkbox v-model="checked"></el-checkbox>
                    我同意<span class="active" @click="toReg">《云题库注册协议》</span>和<span class="active" @click="toSecret">《隐私政策》</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { getValidateImg,login,sendSms,register } from '@/api'
export default {
    data(){
        var checkAccount = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('手机号/账号不能为空'));
            }else{
                callback();
            }
        };
        var checkCode = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('验证码不能为空'));
            }else{
                callback();
            }
        };
        var validatePass = (rule, value, callback) => {
            if (value === '') {
                return callback(new Error('请输入密码'));
            }else{
                callback();
            }
        };
        var checkPhone = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('手机号不能为空'));
            }else{
                if(!(/^1[3456789]\d{9}$/.test(value))){
                    return callback(new Error('请填写正确的手机号码'));
                }else{
                    callback();
                }
            }
        };
        var checkCode1 = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('短信验证码不能为空'));
            }else{
                callback();
            }
        };
        var checkimgCode = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('验证码不能为空'));
            }else{
                callback();
            }
        };
        var regPhone = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('手机号不能为空'));
            }else{
                if(!(/^1[3456789]\d{9}$/.test(value))){
                    return callback(new Error('请填写正确的手机号码'));
                }else{
                    callback();
                }
            }
        };
        var regCode = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('短信验证码不能为空'));
            }else{
                callback();
            }
        };
        var regPass = (rule, value, callback) => {
            if (value === '') {
                return callback(new Error('请输入6-32位字母、数字组合的密码'));
            }else{
                callback();
            }
        };
        return {
            checked: false,
            saveImg: '',// 图片验证码
            weixin: require('@/assets/icon_weixin.png'),
            login: true, // 用来控制登录和注册的切换
            phoneLogin: false, // 是否是手机号短信验证码登录
            disabled: false, // 是否可以点击获取验证码
            timeText: '', // 倒计时文案
            ruleForm: {
                account: '',
                pass: '',
                code: ''
            }, // 密码登录表单数据
            rules: { // 密码登录表单验证
                pass: [
                    { validator: validatePass, trigger: 'blur' }
                ],
                account: [
                    { validator: checkAccount, trigger: 'blur' }
                ],
                code: [
                    { validator: checkCode, trigger: 'blur' }
                ],
            },
            phoneForm: {
                phone: '',
                code: '',
                imgCode: ''
            }, // 短信登录表单数据
            phoneRules: { // 短信登录表单验证
                phone: [
                    { validator: checkPhone, trigger: 'blur' }
                ],
                code: [
                    { validator: checkCode1, trigger: 'blur' }
                ],
                imgCode: [
                    { validator: checkimgCode, trigger: 'blur' }
                ]
            },
            phoneReg: {
                phone: '',
                code: '',
                pass: '',
                imgCode: ''
            }, // 手机号注册表单数据
            phoneRegRules: { // 手机号注册表单验证
                phone: [
                    { validator: regPhone, trigger: 'blur' }
                ],
                code: [
                    { validator: regCode, trigger: 'blur' }
                ],
                imgCode: [
                    { validator: checkimgCode, trigger: 'blur' }
                ],
                pass: [
                    { validator: regPass, trigger: 'blur' }
                ],
            },
        }
    },
    created(){
        this.login = localStorage.getItem('login') === null ? true : localStorage.getItem('login');
        this.login = this.login === 'true' ? true : false;
        this.requsetValidateImg();
    },
    methods: {
        toReg(){
            const url = this.$router.resolve({name: 'RegAgree'})
            window.open(url.href,'_blank')
        },
        toSecret(){
            const url = this.$router.resolve({name: 'Secret'})
            window.open(url.href,'_blank')
        },
        requsetValidateImg(){
            getValidateImg({
                random: Math.random()
            }).then((data) => {
                this.saveImg = `data:image/jpg;base64,${data.data.img}`;
            }).catch(e => {
                console.log(e);
            })
        },
        loginHandle(){
            if(this.timeInter){
                clearInterval(this.timeInter);
                this.disabled = false;
            }
            this.turnType(true);
        },
        regHandle(){
            this.turnType(false);
            if(this.timeInter){
                clearInterval(this.timeInter);
                this.disabled = false;
            }
        },
        // 切换登录和注册时清空输入信息
        turnType(isLogin){
            this.$refs['phoneForm'].resetFields();
            this.$refs['ruleForm'].resetFields();
            this.$refs['phoneReg'].resetFields();
            this.requsetValidateImg();
            this.login = isLogin;
            localStorage.setItem('login',isLogin);
        },
        // 点击短信登录
        nodeLogin(){
            this.$refs['ruleForm'].resetFields();
            this.phoneLogin = true;
            this.requsetValidateImg();
        },
        // 点击密码登录
        passLogin(){
            if(this.timeInter){
                clearInterval(this.timeInter);
                this.disabled = false;
            }
            this.$refs['phoneForm'].resetFields();
            this.phoneLogin = false;
            this.requsetValidateImg();
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    // 密码登录
                    if(formName === 'ruleForm'){
                        let { account,pass,code } = this.ruleForm;
                        this.loginFn({
                            ucode: account,
                            pwd: pass,
                            vcode: code,
                            returnUrl: '',
                            type: 0,
                            type_src: 0, //0-官网；1-题库PC；2-题库组卷微信小程序；3-后台管理；4-考试
                        })
                    }else if(formName === 'phoneForm'){ // 短信登录
                        let { phone,code,imgCode } = this.phoneForm;
                        this.loginFn({
                            ucode: phone,
                            pwd: code,
                            vcode: imgCode,
                            returnUrl: '',
                            type: 1,
                            type_src: 0
                        })
                    }else{ // 注册
                        let { phone,code,pass } = this.phoneReg;
                        register({
                            phone,
                            code,
                            pwd: pass,
                            type_src: 0
                        }).then(data => {
                            if(data.data.ok === 0){
                                localStorage.setItem('token',data.data.token);
                                localStorage.setItem('user',data.data.name);
                                
                                this.$router.push({
                                    name: 'Home'
                                })
                            }else if(data.data.ok === 400){
                                this.disabled = false;
                                clearInterval(this.timeInter);
                            }
                        }).catch(e => {
                            console.log(e);
                        })
                    }
                } else {
                    return false;
                }
            });
        },
        loginFn(params){
            login(params).then(data => {
                if(data.data.ok === 0){
                    localStorage.setItem('token',data.data.token);
                    localStorage.setItem('user',data.data.name);
                    this.$router.push({
                        name: 'Home'
                    })
                }else if(data.data.ok === 400){
                    this.disabled = false;
                    clearInterval(this.timeInter);
                }
            }).catch(e => {
                console.log(e);
            })
        },
        // 获取手机短信验证码
        getPhoneCode(formName){
            this.$refs[formName].validateField('phone',(valid) => {
                if(!valid){
                    this.$refs[formName].validateField('imgCode',(imgvalid) => {
                        if(!imgvalid){
                            this.disabled = true;
                            var count = 60;
                            this.timeText = count + 's后重新获取';
                
                            this.timeInter = setInterval(() => {
                                count--;
                                this.timeText = count + 's后重新获取';
                                // 如果倒计时为0,按钮可以点击重新获取验证码
                                if(count === 0){
                                    this.disabled = false;
                                    clearInterval(this.timeInter);
                                }
                            },1000)
        
                            let vcode = '';// 图形验证码
                            let phone = ''; // 手机号
                            if(formName === 'phoneForm'){ //登录
                                vcode = this.phoneForm.imgCode;
                                phone = this.phoneForm.phone;
                            }else{ // 注册
                                vcode = this.phoneReg.imgCode;
                                phone = this.phoneReg.phone;
                            }
                            sendSms({
                                vcode, // 图形验证码
                                phone,
                                type: formName === 'phoneForm' ? 1 : 0 // 0是注册，1是登录
                            }).then(data => {
                                if(data.data.ok === 400){
                                    this.disabled = false;
                                    clearInterval(this.timeInter);
                                }
                            }).catch(e => {
                                console.log(e);
                            })
                        }
                    })
                }else{
                    return false;
                }
            });
        },
    }
}
</script>
<style scoped lang="less">
    .login{
        width: 900px;
        height: 500px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        display: flex;
        background: #fff;
        .left{
            flex: 1;
            background: url('../assets/img_z.png') no-repeat center center;
            background-size: 100% 100%;
        }
        .login-wrapper{
            width: 420px;
            box-sizing: border-box;
            position: relative;
            padding: 50px 40px 0 40px;
            .login-content{
                width: 300px;
                margin: 0 auto;
            }
            .reg-main{
                width: 300px;
                margin: 0 auto;
                .word{
                    font-size: 13px;
                    color: #989898;
                }
                .active{
                    color: #FF824F;
                    cursor: pointer;
                }
            }
            .turn{
                display: flex;
                justify-content: center;
                font-size: 16px;
                span{
                    border-bottom: 3px solid transparent;
                    color: #000000;
                    font-weight: 500;
                    cursor: pointer;
                    padding-bottom: 6px;
                    &:nth-of-type(1){
                        margin-right: 50px;
                    }
                }
                .selected{
                    border-bottom-color: #FEB72C;
                    color: #323232;
                }
            }
            .el-form{
                margin-top: 30px;
                .el-form-item__content{
                    margin-left: 0!important;
                }
                .code-img{
                    width: 90px;
                    height: 40px;
                    margin-left: 30px;
                    cursor: pointer;
                }
                .el-button--warning{
                    width: 100%;
                    background-color: #FEB72C;
                    border-color: #FEB72C;
                }
            }
            .phone-form{
                .code-item{
                    .el-button--warning{
                        width: 120px;
                        margin-left: 10px;
                        float: right;
                        padding: 12px 10px;
                    }
                    .disabled{
                        background-color: #acacac;
                        color: #fff;
                        border-color: #acacac;
                    }
                }
            }
            .node{
                color: #989898;
                font-size: 10px;
                text-align: right;
                cursor: pointer;
                float: right;
                user-select: none;
            }
            .login-bottom{
                position: absolute;
                bottom: 30px;
                width: 300px;
                .fast-login{
                    text-align: center;
                    img{
                        cursor: pointer;
                    }
                }
            }
        }
    }
</style>
<style lang="less">
    .login-wrapper{
        .el-divider--horizontal{
            margin: 0 auto;
            margin-bottom: 30px;
            width: 90%;
            .el-divider__text{
                color: #989898;
                font-size: 10px;
            }
        }
        .el-form-item__content{
            margin-left: 0!important;
        }
        .code-item{
            .el-input{
                width: 170px;
            }
            
        }
        .el-form-item{
            &:nth-last-child(1){
                margin-bottom: 10px;
                margin-top: 26px;
            }
        }
    }
    
</style>
<style lang="less">
.login{
    .el-checkbox__inner:hover{
        border-color: #feb72c;           
    }
    .el-checkbox__input.is-checked .el-checkbox__inner,.el-checkbox__input.is-indeterminate .el-checkbox__inner{
        background-color: #feb72c;
        border-color: #feb72c;
    }
    .el-checkbox__input.is-focus .el-checkbox__inner{
        border-color: #feb72c;
    }
    .el-checkbox__inner{
        width: 16px;
        height: 16px;
    }
    .el-checkbox__inner::after{
        left: 5px;
        top: 2px;
    }
}
    
</style>